import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const EmergencyContactConsentLazy = lazyLoader(
  () =>
    import(
      './EmergencyContactConsent' /* webpackChunkName: "emergency-contact-consent" */
    ),
);

const EmergencyContactConsent = () => {
  return (
    <Suspense fallback={null}>
      <EmergencyContactConsentLazy />
    </Suspense>
  );
};

export default EmergencyContactConsent;
